import { restApiClient } from '@/datasources';
import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { AppointmentMode } from '@/types/enums/appointments.enum';

export interface NextAppointmentPartner {
  socialName: string;
  avatar?: string;
}

export interface NextAppointmentProfessional {
  name: string;
  honorific: string;
  avatar?: string;
}

export interface NextAppointmentItem {
  procedure: {
    name: string;
    procedureType: string;
  };
}

export interface NextAppointment {
  id: string;
  date: string | null;
  slotEnd?: string | null;
  items: NextAppointmentItem[];
  mode: AppointmentMode;
  scheduleType?: ScheduleType | null;
  partner?: NextAppointmentPartner;
  professional?: NextAppointmentProfessional;
}

export async function getNextAppointments(): Promise<NextAppointment[]> {
  const { data } = await restApiClient.get<NextAppointment[]>('/online/customers/next-appointments');

  return data;
}
